import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem("token") !== null;
  const location = useLocation();

  return isAuthenticated ? children : <Navigate to="/" state={{ from: location }} replace />;
};

export default PrivateRoute;
